import { z } from "zod";

export const S3FileLocationDtoSchema = z.object({
  bucket: z.string(),
  key: z.string(),
});
export type S3FileLocationDto = z.infer<typeof S3FileLocationDtoSchema>;
